import { createContext, useContextSelector } from '@fluentui/react-context-selector';
import type { Context, ContextSelector } from '@fluentui/react-context-selector';
import type { ReferenceListState } from '../ReferenceList';

/**
 * Context shared between ReferenceList and its children components
 */
export type ReferenceListContextValue = Pick<
  ReferenceListState,
  | 'areReferencesExpanded'
  | 'maxVisibleReferences'
  | 'overflowButtonTriggeredViaKeyboard'
  | 'referenceListRef'
  | 'shouldUseOverflow'
  | 'totalReferencesCount'
>;

export const ReferenceListContext: Context<ReferenceListContextValue> = createContext<
  ReferenceListContextValue | undefined
>(undefined) as Context<ReferenceListContextValue>;

const referenceListContextDefaultValue: ReferenceListContextValue = {
  areReferencesExpanded: false,
  maxVisibleReferences: undefined,
  overflowButtonTriggeredViaKeyboard: { current: false },
  referenceListRef: { current: null },
  shouldUseOverflow: false,
  totalReferencesCount: 0,
};

export const ReferenceListContextProvider = ReferenceListContext.Provider;

export const useReferenceListContext_unstable = <T>(selector: ContextSelector<ReferenceListContextValue, T>): T =>
  useContextSelector(ReferenceListContext, (ctx = referenceListContextDefaultValue) => selector(ctx));
